import { createContext, useCallback, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SearchUsersRequest } from 'user/models/SearchUsersRequest';

interface IUserListContext {
  searchParams: SearchUsersRequest | null;
  searchUsers: (request: SearchUsersRequest) => void;
  reloadToken: number;
  reloadUsersAndFilters: () => void;
}

export const UserListContext = createContext<IUserListContext>({
  searchParams: {},
  searchUsers: () => {},
  reloadToken: 0,
  reloadUsersAndFilters: () => {},
});

export const UserListProvider = ({ children }) => {
  const [searchParamsUrl, setSearchParamsUrl] = useSearchParams();
  const [reloadToken, setReloadToken] = useState(0);

  const searchParams: SearchUsersRequest = useMemo(() => {
    return {
      detalle: searchParamsUrl.get('detalle'),
      username: searchParamsUrl.get('username'),
      numeroCuentaControlada: searchParamsUrl.get('numeroCuentaControlada'),
      page: searchParamsUrl.get('page') == null ? 0 : Number(searchParamsUrl.get('page')),
      size:
        searchParamsUrl.get('size') == null ? 15 : Number(searchParamsUrl.get('size')),
    };
  }, [searchParamsUrl]);

  const searchUsers = useCallback(
    (request: SearchUsersRequest) => {
      const rawData = {
        numeroCuentaControlada: request.numeroCuentaControlada,
        username: request.username,
        detalle: request.detalle,
      };
      // Filtramos valores nulos
      const cleanEntries = Object.entries(rawData)
        .filter(([_, value]) => value !== undefined && value !== null && value !== '')
        .map(([key, value]) => [key, String(value)]);
      setSearchParamsUrl(new URLSearchParams(cleanEntries));
      setReloadToken((v) => v + 1);
    },
    [setSearchParamsUrl],
  );

  const reloadUsersAndFilters = useCallback(() => {
    setReloadToken((v) => v + 1);
  }, []);

  return (
    <UserListContext.Provider
      value={{
        searchParams,
        searchUsers,
        reloadToken,
        reloadUsersAndFilters,
      }}
    >
      {children}
    </UserListContext.Provider>
  );
};
